const securityLevels = [
	{
		description:
			"Schutz gegen leichte mechanisch wirkende Einbruchwerkzeuge. Schutz gegen leichte Brände.",
		isSuitableForPrivate: true,
		isSuitableForBusiness: false,
		isValid: false,
		resistanceUnits: "-",
		name: "B",
		label: "Sicherheitsstufe B nach VDMA 24992(Stand 05/1995)",
		color: "#C3CFD3",
	},
	{
		description:
			"Weitgehender Schutz gegen mechanisch wirkende Einbruchwerkzeuge für Tür und Korpus. Verankerungstest bei freistehenden Schränken. Schutz gegen leichte Brände.",
		insuranceSumPrivateEur: 250000,
		isSuitableForPrivate: true,
		isSuitableForBusiness: false,
		isValid: true,
		resistanceUnits: "-",
		name: "S1",
		label: "Sicherheitsstufe S1 nach EN 14 450",
		color: "#F8FAFB",
	},
	{
		description:
			"Weitgehender Schutz gegen mechanisch wirkende Einbruchwerkzeuge für Tür und Korpus. Verankerungstest bei freistehenden Schränken. Schutz gegen leichte Brände.",
		insuranceSumPrivateEur: 250000,
		isSuitableForPrivate: true,
		isSuitableForBusiness: false,
		isValid: true,
		resistanceUnits: "-",
		name: "S2",
		label: "Sicherheitsstufe S2 nach EN 14 450",
		color: "#C3CFD3",
	},
	{
		description:
			"Definierter und typgeprüfter Einbruchschutz gegen Angriffe mit mechanisch und thermisch wirkenden Werkzeugen von 30/30 RU*.",
		insuranceSumBusinessEur: 1000000,
		insuranceSumPrivateEur: 4000000,
		isSuitableForPrivate: true,
		isSuitableForBusiness: true,
		isValid: true,
		resistanceUnits: "30/30",
		name: "0",
		label: "Sicherheitsstufe 0 nach EN 1143-1",
		color: "rgba(0,161,178,0.05)",
	},
	{
		description:
			"Definierter und typgeprüfter Einbruchschutz gegen Angriffe mit mechanisch und thermisch wirkenden Werkzeugen von 30/50 RU*.",
		insuranceSumBusinessEur: 2000000,
		insuranceSumPrivateEur: 6500000,
		isSuitableForPrivate: true,
		isSuitableForBusiness: true,
		isValid: true,
		resistanceUnits: "30/50",
		name: "1",
		label: "Sicherheitsstufe 1 nach EN 1143-1",
		color: "rgba(0,161,178,0.15)",
	},
	{
		description:
			"Definierter und typgeprüfter Einbruchschutz gegen Angriffe mit mechanisch und thermisch wirkenden Werkzeugen von 50/80 RU*.",
		insuranceSumBusinessEur: 4000000,
		insuranceSumPrivateEur: 10000000,
		isSuitableForPrivate: true,
		isSuitableForBusiness: true,
		isValid: true,
		resistanceUnits: "50/80",
		name: "2",
		label: "Sicherheitsstufe 2 nach EN 1143-1",
		color: "rgba(0,161,178,0.25)",
	},
	{
		description:
			"Definierter und typgeprüfter Einbruchschutz gegen Angriffe mit mechanisch und thermisch wirkenden Werkzeugen von 80/120 RU*.",
		insuranceSumBusinessEur: 10000000,
		insuranceSumPrivateEur: 20000000,
		isSuitableForPrivate: true,
		isSuitableForBusiness: true,
		isValid: true,
		resistanceUnits: "80/120",
		norm: "EN 1143-1",
		name: "3",
		label: "Sicherheitsstufe 3 nach EN 1143-1",
		color: "rgba(0,161,178,0.35)",
	},
	{
		description:
			"Definierter und typgeprüfter Einbruchschutz gegen Angriffe mit mechanisch und thermisch wirkenden Werkzeugen von 120/180 RU*.",
		insuranceSumBusinessEur: 15000000,
		insuranceSumPrivateEur: 40000000,
		isSuitableForPrivate: true,
		isSuitableForBusiness: true,
		isValid: true,
		resistanceUnits: "120/180",
		norm: "EN 1143-1",
		name: "4",
		label: "Sicherheitsstufe 4 nach EN 1143-1",
		color: "rgba(0,161,178,0.45)",
	},
	{
		description:
			"Tresore der Sicherheitsstufe 4KB verfügen zusätzlich über einen Kronbohrschutz.",
		insuranceSumBusinessEur: 25000000,
		insuranceSumPrivateEur: 50000000,
		isSuitableForPrivate: true,
		isSuitableForBusiness: true,
		isValid: true,
		resistanceUnits: "-",
		norm: "EN 1143-1",
		name: "4KB",
		label: "Sicherheitsstufe 4KB nach EN 1143-1",
		color: "rgba(0,161,178,0.45)",
	},
	{
		description:
			"Definierter und typgeprüfter Einbruchschutz gegen Angriffe mit mechanisch und thermisch wirkenden Werkzeugen von 180/270 RU*.",
		insuranceSumBusinessEur: 25000000,
		insuranceSumPrivateEur: 50000000,
		isSuitableForPrivate: true,
		isSuitableForBusiness: true,
		isValid: true,
		resistanceUnits: "180/270",
		norm: "EN 1143-1",
		name: "5",
		label: "Sicherheitsstufe 5 nach EN 1143-1",
		color: "rgba(0,161,178,0.6)",
	},
	{
		description:
			"Tresore der Sicherheitsstufe 5KB verfügen zusätzlich über einen Kronbohrschutz.",
		insuranceSumBusinessEur: 37500000,
		insuranceSumPrivateEur: 75000000,
		isSuitableForPrivate: true,
		isSuitableForBusiness: true,
		isValid: true,
		resistanceUnits: "-",
		norm: "EN 1143-1",
		name: "5KB",
		label: "Sicherheitsstufe 5KB nach EN 1143-1",
		color: "rgba(0,161,178,0.6)",
	},
	{
		description:
			"Definierter und typgeprüfter Einbruchschutz gegen Angriffe mit mechanisch und thermisch wirkenden Werkzeugen von 180/270 RU*.",
		insuranceSumBusinessEur: 37500000,
		insuranceSumPrivateEur: 75000000,
		isSuitableForPrivate: true,
		isSuitableForBusiness: true,
		isValid: true,
		resistanceUnits: "180/270",
		norm: "EN 1143-1",
		name: "6",
		label: "Sicherheitsstufe 6 nach EN 1143-1",
		color: "rgba(0,161,178,0.7)",
	},
	{
		description:
			"Tresore der Sicherheitsstufe 6KB verfügen zusätzlich über einen Kronbohrschutz.",
		insuranceSumBusinessEur: 50000000,
		insuranceSumPrivateEur: 100000000,
		isSuitableForPrivate: true,
		isSuitableForBusiness: true,
		isValid: true,
		resistanceUnits: "-",
		norm: "EN 1143-1",
		label: "Sicherheitsstufe 6KB nach EN 1143-1",
		name: "6KB",
		color: "rgba(0,161,178,0.7)",
	},
	{
		description:
			"Definierter und typgeprüfter Einbruchschutz für Deposit-Tresore gegen Angriffe mit mechanisch und thermisch wirkenden Werkzeugen von 30/50 RU* , sowie gegen Gasangriffe.",
		insuranceSumBusinessEur: 2000000,
		insuranceSumPrivateEur: 6500000,
		isSuitableForPrivate: false,
		isSuitableForBusiness: true,
		isValid: true,
		resistanceUnits: "30/50",
		norm: "EN 1143-2",
		label: "Sicherheitsstufe D-I nach EN 1143-2",
		name: "D-I",
		color: "rgba(0,161,178,0.8)",
	},
	{
		description:
			"Definierter und typgeprüfter Einbruchschutz gegen Angriffe mit mechanisch und thermisch wirkenden Werkzeugen von 50/80 RU*.",
		insuranceSumBusinessEur: 4000000,
		insuranceSumPrivateEur: 10000000,
		isSuitableForPrivate: false,
		isSuitableForBusiness: true,
		isValid: true,
		resistanceUnits: "-",
		norm: "EN 1143-2",
		label: "Sicherheitsstufe D-II nach EN 1143-2",
		name: "D-II",
		color: "rgba(0,161,178,0.9)",
	},
	{
		description:
			"Definierter und typgeprüfter Einbruchschutz gegen Angriffe mit mechanisch und thermisch wirkenden Werkzeugen von 80/120 RU*.",
		insuranceSumBusinessEur: 10000000,
		insuranceSumPrivateEur: 20000000,
		isSuitableForPrivate: false,
		isSuitableForBusiness: true,
		isValid: true,
		resistanceUnits: "-",
		norm: "EN 1143-2",
		label: "Sicherheitsstufe D-III nach EN 1143-2",
		name: "D-III",
		color: "rgba(0,161,178,1)",
	},
	{
		description:
			"Schutz gegen leichte mechanisch wirkende Einbruchwerkzeuge. Kein Schutz gegen Brände.",
		isSuitableForPrivate: true,
		isSuitableForBusiness: false,
		isValid: false,
		resistanceUnits: "-",
		name: "A",
		label: "Sicherheitsstufe A nach VDMA 24992 (Stand 05/1995)",
		color: "#F8FAFB",
	},
]

// TODO: Translate the securityLevels
const getSecurityLevelInsurances = (securityGrade: string) => {
	try {
		const data = securityLevels.find(
			(level) => level.name.includes(securityGrade) || level.label.includes(securityGrade),
		)

		if (!data) return null
		return data
	} catch (error) {
		console.error({ error })
		return null
	}
}

export default getSecurityLevelInsurances
